import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { problems } from '../data/problems';
export function ProblemSection() {
  return <section className="bg-field py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-214" data-mp="2lqgv0knlf1t1">
      <div className="mx-auto max-w-4xl px-4" data-id="element-215" data-mp="30iirrvud9eou">
        <div className="text-center" data-id="element-216" data-mp="2vpzb2q0du3ft">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-gold" data-id="element-217" data-mp="2vowogua3en5p">La realidad profesional</p>
          <h2 id="problem-title" className="mx-auto mt-3 max-w-3xl text-balance text-3xl font-extrabold leading-tight text-cream sm:text-4xl" data-id="element-218" data-mp="39jz07y1mf6qf">
            ¿Cuántas clases más vas a preparar sobre Yacimientos de Hidrocarburos sin tener el material correcto?
          </h2>
          <p className="mx-auto mt-5 max-w-3xl leading-relaxed text-field-light" data-id="element-219" data-mp="3eiaag9vtvj96">
            Buscás información en internet que no tiene secuencia didáctica ni menciona la realidad geológica de los
            yacimientos en Argentina. Armás planificaciones desde cero cada ciclo lectivo. Y cuando un alumno pregunta cómo
            se forma un yacimiento, qué es una trampa geológica, qué cuencas petroleras tiene Argentina, cómo funcionan los
            yacimientos no convencionales como Vaca Muerta, cómo se evalúan los recursos, cómo se desarrolla un campo, o qué
            significa realmente trabajar en exploración de hidrocarburos en una empresa argentina en 2026, no tenés una
            respuesta que los enganche con la realidad del campo de los hidrocarburos argentino.
          </p>
          <p className="mt-4 font-bold text-gold" data-id="element-220" data-mp="171efv2rkd343">No es falta de vocación profesional. Es que nadie armó el sistema completo para vos.</p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-9 rounded-xl border border-field-soft bg-field-deep/60 p-6 sm:p-8" data-id="element-221" data-mp="1g348gbx6m83g">
          <p className="mb-5 font-display text-xl font-bold text-cream" data-id="element-222" data-mp="p1bp1r4sywqr">Esto te está pasando ahora mismo:</p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-223" data-mp="k2h8kvub5k9t">
            {problems.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-cream" data-id="element-224" data-mp="y177mh0otu0t">
                <span className="mt-0.5 shrink-0 rounded-md bg-alert/30 p-1" data-id="element-225" data-mp="tyu2nutrm053">
                  <XIcon className="h-3.5 w-3.5 text-red-300" aria-hidden="true" data-id="element-226" data-mp="17z4twyyzlgqs" />
                </span>
                {item}
              </li>)}
          </ul>
        </motion.div>

        <p className="mt-8 text-center font-bold text-gold" data-id="element-227" data-mp="12xxnb38kynlp">
          ¿Y si esta fuera la última semana que enseñás Yacimientos de Hidrocarburos sin tener todo resuelto?
        </p>

        <p className="mx-auto mt-6 max-w-3xl text-center leading-relaxed text-field-light" data-id="element-228" data-mp="1cqd0zocugq0s">
          Con el MEGAPACK YACIMIENTOS DE HIDROCARBUROS LISTO, tu próxima clase ya empieza diferente. Tus alumnos no
          aprenden yacimientos como un conjunto de conceptos abstractos: aprenden que cada formación geológica, cada
          trampa, cada descubrimiento es el resultado de procesos de millones de años y que comprender los yacimientos es
          comprender la energía que mueve el mundo y la economía argentina.
        </p>
      </div>
    </section>;
}